import { createAction, props } from '@ngrx/store';

export const initUser = createAction('[API] Current user set', props<{ userId: string }>());
